/* eslint-disable react/jsx-pascal-case */

import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
} from '../../ui/ot'

const language_culture_code = 'zh-tw'
const BlogCategoryForm = ({
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },

}) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });
    };
    const onValuesChange = (value, { name, type }) => {
         
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    };

    const getLanguageLabel = (language_culture_code) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        return label[language_culture_code];
    };
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };

    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
    }, [formReloadCount]);

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                label="category_id"
                                name={"category_id"}
                                hidden={true}
                            >
                                <Input />
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.List name={"name_language_data"}>
                                {(fields, { add, remove }) => (
                                    <Row>
                                        {fields.map((field) => (
                                            <Col
                                                key={field.id}
                                                span={24}>
                                                <Row>
                                                    <Col span={24}>
                                                        <Form.Item
                                                            hidden={true}
                                                            name={`${field.name}.language_culture_code`}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={24}>
                                                        <Form.Item
                                                            labelCol={6}
                                                            wrapperCol={
                                                                18
                                                            }
                                                            label={`${getLanguageLabel(field?.language_culture_code)}名稱`}
                                                            name={`${field.name}.language_culture_value`}

                                                            rules={[
                                                                {
                                                                    required: field?.language_culture_code === "zh-tw",
                                                                    message: "此為必填",
                                                                },
                                                            ]}
                                                        >
                                                            <Input />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        ))}

                                    </Row>
                                )}
                            </Form.List>
                        </Col>
                    </Row>
                </Form >
            </Col >
        </Row >
    );
};

export default BlogCategoryForm;


